import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('double-left', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87164 3.16552C9.05637 3.37078 9.03973 3.68692 8.83448 3.87165L4.24742 8L8.83448 12.1284C9.03973 12.3131 9.05637 12.6292 8.87164 12.8345C8.68691 13.0397 8.37077 13.0564 8.16551 12.8717L3.16551 8.37165C3.06016 8.27683 3 8.14175 3 8C3 7.85826 3.06016 7.72318 3.16551 7.62836L8.16551 3.12836C8.37077 2.94363 8.68691 2.96027 8.87164 3.16552Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8716 3.16552C13.0564 3.37078 13.0397 3.68692 12.8345 3.87165L8.24742 8L12.8345 12.1284C13.0397 12.3131 13.0564 12.6292 12.8716 12.8345C12.6869 13.0397 12.3708 13.0564 12.1655 12.8717L7.16551 8.37165C7.06016 8.27683 7 8.14175 7 8C7 7.85826 7.06016 7.72318 7.16551 7.62836L12.1655 3.12836C12.3708 2.94363 12.6869 2.96027 12.8716 3.16552Z",
    fill: props.colors[0]
  }));
});